(function(){
    angular
        .module('app').filter('moment', function () {
		  return function (input, momentFn ) {
		  	moment.locale('es');
		  	// console.log(input);
		    var args = Array.prototype.slice.call(arguments, 2), momentObj = moment(input);
		     
		    return momentObj[momentFn].apply(momentObj, args);
		  };
		});
})();
